module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-from-right-d7ec4b5be2a52e11e6decf4952a9788d.svg";